import { type TableColumn } from '@dev-spendesk/grapes';

import { type Payable } from 'modules/payable/models';
import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';

import {
  AmountCell,
  DateCell,
  DescriptionCell,
  EmployeeCell,
  SupplierCell,
} from './PayableTableCell';

export const payableTableColumns = (
  t: TGlobalFunctionTyped,
): TableColumn<Payable>[] => [
  {
    id: 'supplier',
    header: t('payables.table.supplier'),
    renderCell: (payable) => <SupplierCell payable={payable} />,
    width: 'minmax(160px, 20%)',
  },
  {
    id: 'employee',
    header: t('payables.table.employee'),
    renderCell: (payable) => <EmployeeCell payable={payable} />,
    width: 'minmax(160px, 20%)',
  },
  {
    id: 'amount',
    header: t('payables.table.amount'),
    renderCell: (payable) => <AmountCell payable={payable} />,
    width: 160,
  },
  {
    id: 'description',
    header: t('payables.table.description'),
    renderCell: (payable) => <DescriptionCell payable={payable} />,
    width: '33%',
  },
  {
    id: 'date',
    header: t('payables.table.date'),
    renderCell: (payable) => <DateCell payable={payable} />,
    width: 160,
  },
];
